<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="template">
    <audio id="audioPlayer1" src="https://cdn.exploreve.fr/content/rails/musiques/Aiguillage_1.mp3"></audio>
    <audio id="audioPlayer2" src="https://cdn.exploreve.fr/content/rails/musiques/Aiguillage_2.mp3"></audio>
    <audio id="audioPlayer3" src="https://cdn.exploreve.fr/content/rails/musiques/Aiguillage_3.mp3"></audio>
    <audio id="audioPlayer4" src="https://cdn.exploreve.fr/content/rails/musiques/Aiguillage_4.mp3"></audio>
    <audio id="boum" src="https://cdn.exploreve.fr/content/rails/musiques/Collision train immersion 2 V2.mp3"></audio>
    <audio
      id="roll"
      src="https://cdn.exploreve.fr/content/rails/musiques/Départ et roulage train Immersion 2.mp3"
    ></audio>

    <div class="ct" id="container" v-bind:style="{ width: width + 'px', height: height + 'px' }">
      <div v-for="n in pixels.length" :key="n" @mousedown="fired">
        <div v-for="k in pixels[n - 1].length" :key="k">
          <div v-show="k - 1 == pos[n - 1]">
            <img
              class="pix_train"
              :src="'https://cdn.exploreve.fr/content/rails/' + pixels[n - 1][k - 1] + '.png'"
              alt=""
              :id="n * 1000 + k"
            />
          </div>
        </div>
      </div>
      <div class="red train" id="rt" data-d="" dir="R" loc="56">
        <img src="https://cdn.exploreve.fr/content/cluedo/locomotive-03.png" height="50px" />
      </div>
      <div class="blue train" id="bt"></div>
      <div class="green train" id="gt"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 490,
      height: 490,
      pixels: [
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [4],
        [5, 6, 1],
        [1],
        [1, 2, 4, 5, 6, 7],
        [3],
        [5, 6, 1],
        [7],
        [0],
        [0],
        [0],
        [1],
        [1],
        [1, 4, 7],
        [1],
        [1, 2, 4, 5, 7],
        [1],
        [1, 4, 7],
        [3],
        [3],
        [1],
        [1, 2, 4, 5, 6, 7],
        [1],
        [1],
        [7],
        [1],
        [1],
        [6],
        [0],
        [2],
        [0],
        [2],
        [2],
        [2],
        [0],
        [2],
        [0],
        [0],
        [2],
        [0],
        [0],
        [4],
        [1],
        [1, 2, 3, 4, 6, 7],
        [1],
        [1, 5, 6],
        [3],
        [3],
        [1],
        [3],
        [1],
        [1, 4, 7],
        [6],
        [1],
        [1],
        [6],
        [0],
        [2],
        [0],
        [0],
        [2],
        [2],
        [0],
        [2],
        [0],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2, 4, 5],
        [1],
        [1],
        [3],
        [3],
        [1],
        [3],
        [1],
        [6],
        [0],
        [0],
        [0],
        [0],
        [0],
        [5],
        [1, 4, 7],
        [1],
        [3],
        [3],
        [1, 4, 7],
        [6],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2, 4, 5],
        [2, 6, 7],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2, 4],
        [6],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [0],
        [2],
        [0],
        [2],
        [2],
        [0],
        [0],
        [0],
        [0],
        [0]
      ],
      pos: Array(196).fill(0),
      top_rt: 134,
      left_rt: -20
    };
  },
  mounted() {
    for (let n = 0; n < this.pixels.length; n++) {
      if (this.pixels[n].length > 1) {
        for (let k = 0; k < this.pixels[n].length; k++) {
          var tile = document.getElementById(1000 * (n + 1) + k + 1);
          tile.classList.add("moveable");
        }
      }
      if (n == 5) {
        var tIle = document.getElementById(1000 * (n + 1) + 1);
        tIle.classList.add("target");
      }
    }
  },
  components: {},
  methods: {
    getRandomInt: function (max) {
      return Math.floor(Math.random() * Math.floor(max));
    },

    fired(event) {
      var i = Math.trunc(event.target.id / 1000) - 1;
      if (this.pixels[i].length > 1) {
        let id = this.getRandomInt(4) + 1;
        var player = document.getElementById("audioPlayer" + id);
        player.play();
      }
      this.pos[i] = (this.pos[i] + 1) % this.pixels[i].length;
      this.pos = [...this.pos];
    },

    go() {
      this.anim("rt");
    },

    colli: function () {
      let redTrain = document.getElementById("rt");
      redTrain.addEventListener("animationiteration", this.reset());
    },

    reset: function () {
      let redTrain = document.getElementById("rt");
      redTrain.style.animationPlayState = "paused";
      let roll = document.getElementById("roll");
      let coll = document.getElementById("boum");
      roll.pause();
      coll.play();
      alert(
        "Mince ! Il semblerait que le train soit allé droit dans une impasse... Et si on réessayait ? Clique sur Réessayer puis relance le train"
      );
    },

    success: function () {
      var ref = this;
      let redTrain = document.getElementById("rt");
      redTrain.style.animationPlayState = "paused";
      let roll = document.getElementById("roll");
      roll.pause();
      ref.top_rt = 195;
      ref.left_rt = 273;
      redTrain.setAttribute("loc", 56);
      redTrain.setAttribute("dir", "R");
      this.$emit("success");
    },

    anim(id) {
      let roll = document.getElementById("roll");
      roll.play();

      let redTrain = document.getElementById(id);
      var ref = this;

      redTrain.addEventListener("animationiteration", (event) => {
        let redTrain = document.getElementById("rt");
        let n = parseInt(redTrain.getAttribute("loc"));
        if (n == 19) {
          ref.success();
        } else {
          switch (event.animationName) {
            case "RIGHT":
              ref.left_rt += 35;
              redTrain.setAttribute("loc", n + 1);
              break;
            case "LEFT":
              ref.left_rt -= 35;
              redTrain.setAttribute("loc", n - 1);
              break;
            case "TOP":
              ref.top_rt -= 35;
              redTrain.setAttribute("loc", n - 14);
              if (n - 14 < 0) {
                ref.colli();
              }
              break;
            case "BOT":
              ref.top_rt += 35;
              redTrain.setAttribute("loc", n + 14);
              if (n + 14 > 182) {
                ref.colli();
              }

              break;
            case "RB":
              ref.left_rt += -17.5;
              ref.top_rt += +17.5;
              redTrain.setAttribute("loc", n + 14);
              redTrain.setAttribute("dir", "B");
              break;
            case "BR":
              ref.left_rt += 17.5;
              ref.top_rt += -17.5;
              redTrain.setAttribute("loc", n + 1);
              redTrain.setAttribute("dir", "R");
              break;
            case "TR":
              ref.left_rt += 17.5;
              ref.top_rt += 17.5;
              redTrain.setAttribute("loc", n + 1);
              redTrain.setAttribute("dir", "R");
              break;
            case "RT":
              ref.left_rt += -17.5;
              ref.top_rt += -17.5;
              redTrain.setAttribute("loc", n - 14);
              redTrain.setAttribute("dir", "T");
              break;
            case "LT":
              ref.left_rt += 17.5;
              ref.top_rt += -17.5;
              ref.rotate_rt = -90;
              redTrain.setAttribute("loc", n - 14);
              redTrain.setAttribute("dir", "T");
              break;
            case "TL":
              ref.left_rt += -17.5;
              ref.top_rt += 17.5;
              redTrain.setAttribute("loc", n - 1);
              redTrain.setAttribute("dir", "L");
              break;
            case "BL":
              ref.left_rt += -17.5;
              ref.top_rt += -17.5;
              redTrain.setAttribute("loc", n - 1);
              redTrain.setAttribute("dir", "L");
              break;
            case "LB":
              ref.left_rt += 17.5;
              ref.top_rt += 17.5;
              redTrain.setAttribute("loc", n + 14);
              redTrain.setAttribute("dir", "B");
              break;
          }

          redTrain.style.left = ref.left_rt + "px";
          redTrain.style.top = ref.top_rt + "px";

          n = parseInt(redTrain.getAttribute("loc"));
          if (n < 0 || n >= ref.pos.length) {
            this.reset();
          } else {
            let type = ref.pixels[n][ref.pos[n]];
            if (type == 1) {
              if (redTrain.getAttribute("dir") == "R") {
                let next = ref.pixels[n + 1][ref.pos[n + 1]];
                redTrain.setAttribute("data-d", "RIGHT");
                if (!(next == 1 || next == 3 || next == 6 || next == 7)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[n - 1][ref.pos[n - 1]];
                redTrain.setAttribute("data-d", "LEFT");
                if (!(next == 1 || next == 3 || next == 4 || next == 5)) {
                  ref.colli();
                }
              }
            }
            if (type == 2) {
              if (redTrain.getAttribute("dir") == "B") {
                let next = ref.pixels[(n + 14) % 196][ref.pos[(n + 14) % 196]];
                redTrain.setAttribute("data-d", "BOT");
                if (!(next == 2 || next == 3 || next == 5 || next == 6)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[Math.abs(n - 14)][ref.pos[Math.abs(n - 14)]];
                redTrain.setAttribute("data-d", "TOP");
                if (!(next == 2 || next == 3 || next == 7 || next == 4)) {
                  ref.colli();
                }
              }
            }
            if (type == 3) {
              if (redTrain.getAttribute("dir") == "B") {
                let next = ref.pixels[n + 14][ref.pos[n + 14]];
                redTrain.setAttribute("data-d", "BOT");
                if (!(next == 2 || next == 3 || next == 5 || next == 6)) {
                  ref.colli();
                }
              }
              if (redTrain.getAttribute("dir") == "R") {
                let next = ref.pixels[n + 1][ref.pos[n + 1]];
                redTrain.setAttribute("data-d", "RIGHT");
                if (!(next == 1 || next == 3 || next == 6 || next == 7)) {
                  ref.colli();
                }
              }
              if (redTrain.getAttribute("dir") == "T") {
                let next = ref.pixels[n - 14][ref.pos[n - 14]];
                redTrain.setAttribute("data-d", "TOP");
                if (!(next == 2 || next == 3 || next == 7 || next == 4)) {
                  ref.colli();
                }
              }
              if (redTrain.getAttribute("dir") == "L") {
                let next = ref.pixels[n + 1][ref.pos[n + 1]];
                redTrain.setAttribute("data-d", "LEFT");
                if (!(next == 1 || next == 3 || next == 4 || next == 5)) {
                  ref.colli();
                }
              }
            }
            if (type == 4) {
              if (redTrain.getAttribute("dir") == "T") {
                let next = ref.pixels[n + 1][ref.pos[n + 1]];
                redTrain.setAttribute("data-d", "BR");
                if (!(next == 1 || next == 3 || next == 6 || next == 7)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[n + 14][ref.pos[n + 14]];
                redTrain.setAttribute("data-d", "RB");
                if (!(next == 2 || next == 3 || next == 5 || next == 6)) {
                  ref.colli();
                }
              }
            }
            if (type == 5) {
              if (redTrain.getAttribute("dir") == "B") {
                let next = ref.pixels[n + 1][ref.pos[n + 1]];
                redTrain.setAttribute("data-d", "TR");
                if (!(next == 1 || next == 3 || next == 6 || next == 7)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[n - 14][ref.pos[n - 14]];
                redTrain.setAttribute("data-d", "RT");
                if (!(next == 2 || next == 3 || next == 4 || next == 7)) {
                  ref.colli();
                }
              }
            }
            if (type == 6) {
              if (redTrain.getAttribute("dir") == "R") {
                let next = ref.pixels[n - 14][ref.pos[n - 14]];
                redTrain.setAttribute("data-d", "LT");
                if (!(next == 2 || next == 3 || next == 4 || next == 7)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[n - 1][ref.pos[n - 1]];
                redTrain.setAttribute("data-d", "TL");
                if (!(next == 1 || next == 3 || next == 4 || next == 5)) {
                  ref.colli();
                }
              }
            }
            if (type == 7) {
              if (redTrain.getAttribute("dir") == "T") {
                let next = ref.pixels[n - 1][ref.pos[n - 1]];
                redTrain.setAttribute("data-d", "BL");
                if (!(next == 1 || next == 3 || next == 4 || next == 5)) {
                  ref.colli();
                }
              } else {
                let next = ref.pixels[n + 14][ref.pos[n + 14]];
                redTrain.setAttribute("data-d", "LB");
                if (!(next == 2 || next == 3 || next == 5 || next == 6)) {
                  ref.colli();
                }
              }
            }
          }
        }
      });

      redTrain.setAttribute("data-d", "RIGHT");
      redTrain.style.animationPlayState = "running";
    }
  }
};
</script>

<style lang="scss">
div.ct {
  margin: 0 auto;
  background: white;
}

.pix_train {
  height: 35px;
  float: left;
  margin: 0;
  border: 1px solid grey;
}

.moveable {
  height: 35px;
  float: left;
  margin: 0;
  border: 1px solid red;
}

.target {
  height: 35px;
  float: left;
  margin: 0;
  border: 2px solid blue;
}

.train {
  position: absolute;
  pointer-events: none;
  user-select: none;
}

.red {
  top: 134px;
  left: -20px;
}
.red_goal {
  color: red;
  position: relative;
  top: -510px;
  left: -52.5px;
  font-size: 20px;
}

@keyframes RIGHT {
  from {
    transform: translateX(0px) rotate(0deg);
  }
  to {
    transform: translateX(35px) rotate(0deg);
  }
}

@keyframes LEFT {
  from {
    transform: translateX(0px) rotate(-180deg);
  }
  to {
    transform: translateX(-35px) rotate(-180deg);
  }
}

@keyframes BOT {
  from {
    transform: translateY(0px) rotate(90deg);
  }
  to {
    transform: translateY(35px) rotate(90deg);
  }
}

@keyframes TOP {
  from {
    transform: translateY(0px) rotate(-90deg);
  }
  to {
    transform: translateY(-35px) rotate(-90deg);
  }
}

@keyframes RB {
  from {
    transform: translate(0px, 0px) rotate(180deg);
  }
  to {
    transform: translate(-17.5px, 17.5px) rotate(90deg);
  }
}

@keyframes BR {
  0% {
    transform: translate(0px, 0px) rotate(-90deg);
  }
  100% {
    transform: translate(17.5px, -17.5px) rotate(0deg);
  }
}

@keyframes TR {
  from {
    transform: translate(0px, 0px) rotate(90deg);
  }
  to {
    transform: translate(17.5px, 17.5px) rotate(0deg);
  }
}

@keyframes RT {
  from {
    transform: translate(0px, 0px) rotate(180deg);
  }
  to {
    transform: translate(-17.5px, -17.5px) rotate(270deg);
  }
}

@keyframes LT {
  0% {
    transform: translate(0px, 0px) rotate(0deg);
  }
  100% {
    transform: translate(17.5px, -17.5px) rotate(-90deg);
  }
}

@keyframes TL {
  from {
    transform: translate(0px, 0px) rotate(90deg);
  }
  to {
    transform: translate(-17.5px, 17.5px) rotate(180deg);
  }
}

@keyframes BL {
  from {
    transform: translate(0px, 0px) rotate(270deg);
  }
  to {
    transform: translate(-17.5px, -17.5px) rotate(180deg);
  }
}

@keyframes LB {
  from {
    transform: translate(0px, 0px) rotate(0deg);
  }
  to {
    transform: translate(17.5px, 17.5px) rotate(90deg);
  }
}

.train[data-d="LEFT"] {
  animation: LEFT 0.5s linear infinite;
}

.train[data-d="RIGHT"] {
  animation: RIGHT 0.5s linear infinite;
}

.train[data-d="TOP"] {
  animation: TOP 0.5s linear infinite;
}

.train[data-d="BOT"] {
  animation: BOT 0.5s linear infinite;
}

.train[data-d="RB"] {
  animation: RB 0.5s linear infinite;
}

.train[data-d="BR"] {
  animation: BR 0.5s linear infinite;
}

.train[data-d="TR"] {
  animation: TR 0.5s linear infinite;
}

.train[data-d="RT"] {
  animation: RT 0.5s linear infinite;
}

.train[data-d="LT"] {
  animation: LT 0.5s linear infinite;
}

.train[data-d="TL"] {
  animation: TL 0.5s linear infinite;
}

.train[data-d="LB"] {
  animation: LB 0.5s linear infinite;
}

.train[data-d="BL"] {
  animation: BL 0.5s linear infinite;
}
</style>
